const getDefaultState = () => {
    return {
        fundDetails: [],
        FundOptions:[], // Fund Lookup (not filtered)
        FundOptionsFiltered:[],
        FundList:[
            {
                label:"No Options",
                value:"None",
            }
        ], // to be listed in Dropdown (filtered)
        PRSFundOptions:[],
        UTFundOptions:[],
    }
}

const state = getDefaultState()

// getters
const getters = { 
}


// actions
const actions = {
    UpdateFundList({state,commit,dispatch}, Obj) { 
      //  FundList
      //  UpdateFundList : (state,value) = > state.FundList = 
         dispatch('FilterFundOptions', Obj) 
    },
    FindMinimumTransaction({state,commit}, Obj){
        //console.log(Obj)
        var MinimumInvestmentAmount = 0;
        var MinimumSwitchingUnits = 0;
        var MinimumAdditionalAmount = 0;
        //var MinimumRedemptionAmount = 0;
        for(var i=0;i<state.FundOptions.length;i++){
            if(state.FundOptions[i].Scheme===Obj.Scheme){
                MinimumInvestmentAmount = state.FundOptions[i].minintamount;
                MinimumSwitchingUnits = state.FundOptions[i].minswitchunits;
                MinimumAdditionalAmount = state.FundOptions[i].minaddamount;
                //MinimumRedemptionAmount = state.FundOptions[i].miniredemptamount;
            }
        }
        return { MinimumInvestmentAmount, MinimumSwitchingUnits, MinimumAdditionalAmount }
    },
    FindMaximumSalesCharge({state,commit},Obj){
        if(Obj.Plan==='CS'){
            Obj.Plan='Cash'
        }
        var MaximumSalesCharge = 0;
        for(var i=0;i<state.FundOptions.length;i++){
            if(state.FundOptions[i].Scheme===Obj.Scheme){
                if(state.FundOptions[i].FeeCharges!==undefined){
                    for(var j=0;j<state.FundOptions[i].FeeCharges.length;j++){
                        if(state.FundOptions[i].FeeCharges[j].Plan === Obj.Plan){   
                            MaximumSalesCharge = state.FundOptions[i].FeeCharges[j].RatePerc
                        }
                    }
                }
            }
        }
        return { MaximumSalesCharge }
    },
    FilterFundOptions({ state, rootState }, Obj){
        state.FundOptionsFiltered=[];
        for(var i=0;i< rootState.Lookup.Schemes_LK.length;i++){
            if((rootState.Lookup.Schemes_LK[i].EPFStatus=="Approved")){
               // for(var j=0;j<rootState.Lookup.Schemes_LK[i].FeeCharges.length;j++){
                    if(rootState.Lookup.Schemes_LK[i].Scheme != rootState.CD.Transaction.FundSwitchOut){
                       // if("EPF"===rootState.Lookup.Schemes_LK[i].FeeCharges[j].Plan ){
                            state.FundOptionsFiltered.push({ 
                                label:rootState.Lookup.Schemes_LK[i].label,
                                value:rootState.Lookup.Schemes_LK[i].value,
                                Scheme:rootState.Lookup.Schemes_LK[i].Scheme,
                                SchemeName:rootState.Lookup.Schemes_LK[i].SchemeName,
                                currency:rootState.Lookup.Schemes_LK[i].currency,
                                minintamount:rootState.Lookup.Schemes_LK[i].minintamount,
                                minaddamount:rootState.Lookup.Schemes_LK[i].minaddamount,
                                minswitchunits:rootState.Lookup.Schemes_LK[i].minswitchunits,
                                PRSAgeLowerBound:rootState.Lookup.Schemes_LK[i].PRSAgeLowerBound,
                                PRSAgeUpperBound:rootState.Lookup.Schemes_LK[i].PRSAgeUpperBound,
                                SalesCharge:'0.00',
                                //rootState.Lookup.Schemes_LK[i].FeeCharges[j].RatePerc.toFixed(2),
                                producttype:rootState.Lookup.Schemes_LK[i].producttype,
                                ProductAssetClass : rootState.Lookup.Schemes_LK[i].ProductAssetClass,
                                RiskProfile : rootState.Lookup.Schemes_LK[i].RiskProfile,
                                FundStructure: rootState.Lookup.Schemes_LK[i].FundStructure,
                                Plan:'EPF',
                                ProductManagerMaster:rootState.Lookup.Schemes_LK[i].ProductManagerMaster,
                                //rootState.Lookup.Schemes_LK[i].FeeCharges[j].Plan
                            });

                      //  }
                    }    
               // }
            }
        }


        //console.log("after ->" + state.FundOptionsFiltered.length)
        //console.log(state.FundOptionsFiltered)
        //console.log('Filter end')       
    }
}

// mutations
const mutations = {
    //UpdateFundList: (state, value) => state.FundList = value,
    ResetState_Product (state) {
        Object.assign(state, getDefaultState())
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}